import PromisedResource from './PromisedResource'

export default class ClientResource extends PromisedResource {
  constructor({ remote, id }) {
    super(remote.query(q => q.findRecord({type: 'client', id: id})))
  }
}
